import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import { NavElements } from "../NavElements"

const NavData = graphql`
  {
    wpMenu(slug: { eq: "footer-columns-pl" }) {
      menuItems {
        nodes {
          path
          label
          id
        }
      }
    }
  }
`

const PolishColumnsNav = () => {
  const navData = useStaticQuery(NavData)
  const elements = navData.wpMenu.menuItems.nodes

  return <NavElements {...{ elements }} alignment="vertical" />
}

export default PolishColumnsNav
